<template>
  <div>
    <Head style="backgroundcolor: #fff"></Head>
    <navigationbar ref="navbar"></navigationbar>
    <div class="firstdiv"></div>
    <div class="content flex flex-direction align-center">
      <div
        class="flex width"
        style="height: auto; margin-top: 0.4rem; z-index: 3"
      >
        <div class="left flex flex-direction">
          <div
            class="itemdiv"
            style="margin-bottom: 0.17rem"
            v-for="(item, index) in catalogs"
            :key="index"
          >
            <div
              @click="onitemCheck(index)"
              class="line font-size-26 font-color-40 cursor-pointer"
              :class="index == indexcheck ? ' font-color-00' : ''"
            >
              <p>{{ item.CatalogName }}</p>

              <img
                :class="index == indexcheck ? 'img3' : 'img2'"
                src="../../../assets/tab/arraw.png"
                alt=""
              />
            </div>
            <div :class="index == indexcheck ? 'show' : 'hidden'">
              <div
                @click="onitemCheckEr(itemer.Id)"
                class="font-size-22 catalogs"
                :class="itemer.Id == erindexId ? 'actiivtyli' : ''"
                v-for="(itemer, erindex) in erCatalogs"
                :key="erindex"
              >
                <p class="radia"></p>
                {{ itemer.CatalogName }}
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div v-if="course_length > 0" class="flex flex-direction">
            <div class="itemdiv">
              <courseItem
                v-for="(item, index) in dataList"
                :key="index"
                :item="item"
                style="margin-top: 0.38rem; margin-left: 0.4rem"
              >
              </courseItem>
            </div>
            <div v-if="totalPage > 1" style="margin: 0.5rem auto">
              <paginate
                :pages="totalPage"
                @jump="jumpPage"
                :groups="totalPage > 5 ? 5 : totalPage"
              ></paginate>
            </div>
          </div>
          <div
            v-else
            class="flex justify-center"
            style="height: 100%; margin-top: 2rem"
          >
            <div v-if="reqend"
              class="empty font-color-94 flex flex-direction align-center font-size-36"
            >
              <img
                style="width: 3.66rem; heigh: 3.32rem"
                src="../../../assets/pserson/empty.png"
              />
              很遗憾！没有相关课程~
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="seconddiv"></div> -->
    </div>
  </div>
</template>

<script>
import common from "@/utils/common.js";
export default {
  data() {
    return {
      indexcheck: 0,
      erindexId: 0,
      Id: 0,
      catalogs: [],
      allCatalogs: [],
      erCatalogs: [],
      cateItem: null,
      dataList: [],
      totalPage: 1,
      pageIndex: 1,
      cateId: 0,
      reqend: false
    };
  },
  computed: {
    course_length() {
      return this.dataList.length;
    },
  },
  activated() {

    for (var i = 0; i < common.cate_fr.length; i ++){
      if (common.cate_fr[i].CatalogType==2){
        console.log('精品乐园id',common.cate_fr[i].Id);
        this.$refs.navbar.setCurrId(common.cate_fr[i].Id, 2,true)
        break
      }
    }
    
    if (this.Id == this.$route.params.Id) {
      console.log('点击相同分类 不处理');
      return
    }
    debugger

    this.erCatalogs = []
    this.pageIndex = 1
    this.Id = this.$route.params.Id
    if (this.catalogs.length > 0) {
      for (let i = 0; i < this.catalogs.length; i++) {
        let item = this.catalogs[i];
        if (item.Id == this.Id) {
          this.indexcheck = i;
          for (var j = 0; j < this.allCatalogs.length; j++) {
            if (this.allCatalogs[j].ParentId == item.Id) {
              this.erCatalogs.push(this.allCatalogs[j]);
            }
          }
          this.erindexId = this.erCatalogs[0].Id;
          break;
        }
      }
    }
    this.getCourses()
  },
  created() {
    let find = false;
    for (let index = 0; index < common.cate_fr.length; index++) {
      const element = common.cate_fr[index];
      if (element.CatalogType == 2) {
        this.erindexId = element.Id;
        this.cateItem = element;
        find = true;
        this.Id = this.$route.params.Id || 0;
        this.getCatalog();
        debugger
        return;
      }
    }
    if (find == false) {
      this.$router.replace({
        name: "home",
      });
    }
  },

  methods: {
    jumpPage(page) {
      this.pageIndex = page;
      this.getCourses();
    },
    // 获取分类
    getCatalog() {
      this.getRequest("api/v1/Catalog", {
        Id: this.cateItem.Id,
      }).then((data) => {
        if (data.IsSuccess) {
          for (var i = 0; i < data.Data.length; i++) {
            if (data.Data[i].Level == 2) {
              if (data.Data[i].Id == this.Id) {
                this.indexcheck = i;
              }
              this.catalogs.push(data.Data[i]);
            } else if (data.Data[i].Level == 3) {
              this.allCatalogs.push(data.Data[i]);
            }
          }

          for (var i = 0; i < this.allCatalogs.length; i++) {
            if (
              this.allCatalogs[i].ParentId == this.catalogs[this.indexcheck].Id
            ) {
              this.erCatalogs.push(this.allCatalogs[i]);
            }
          }
          if (this.erCatalogs.length > 0) {
            this.erindexId = this.erCatalogs[0].Id;
            this.getCourses();
          }
        }
      });
    },
    getCourses() {
      this.getRequest("api/v1/Course/Boutique", {
        CatalogId: this.erindexId,
        PageIndex: this.pageIndex,
        PageSize: 15,
      }).then((data) => {
        if (data.IsSuccess) {
          this.totalPage = data.Data.TotalPage;
          this.dataList = data.Data.DataList;
        }
        this.reqend = true
      });
    },
    onitemCheckEr(index) {
      if (this.erindexId != index) {
        this.erindexId = index;
        this.totalPage = 1;
        this.pageIndex = 1;
        this.getCourses();
      }
    },
    onitemCheck(index) {
      if (this.indexcheck != index) {
        this.indexcheck = index;
        var list = [];
        for (var i = 0; i < this.allCatalogs.length; i++) {
          if (
            this.allCatalogs[i].ParentId == this.catalogs[this.indexcheck].Id
          ) {
            list.push(this.allCatalogs[i]);
          }
        }
        this.erCatalogs = list;
      }
    },
  },
};
</script>

<style scoped>
.left {
  width: 2.42rem;
}

.left .itemdiv {
  width: 2.42rem;
  overflow: hidden;
  min-height: 0.73rem;
  background: #ffffff;
  box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.35);
  border-radius: 0.16rem;
}

.left .itemdiv .line {
  display: flex;
  width: 2.42rem;
  justify-content: space-between;
  text-decoration: none;
  height: 0.73rem;
  padding: 0 0.25rem 0 0.5rem;
  align-items: center;
  cursor: pointer;
}

.left .itemdiv .line:hover {
  color: #000000;
}

.left .itemdiv .line .img1 {
  /* margin-right: 0.1rem; */
  object-fit: fit;
  width: 0.41rem;
  height: 0.41rem;
}

.left .itemdiv .line .img2 {
  margin-left: 0.34rem;
  width: 0.19rem;
  height: 0.11rem;
  /* transform: rotate(180deg); */
}
.left .itemdiv .line .img3 {
  margin-left: 0.34rem;
  width: 0.19rem;
  height: 0.11rem;
  transform: rotate(180deg);
}
.right {
  margin-left: 0.17rem;

  width: 11.22rem;
  /* min-height: 10rem; */
  background: #ffffff;
  box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.35);
  border-radius: 0.16rem;
}

.right .itemdiv {
  flex-wrap: wrap;
  display: flex;
  flex-grow: 1;
  align-content: flex-start;
}
.catalogs {
  width: 100%;
  display: flex;
  text-align: left;
  height: 0.61rem;
  align-items: center;
  padding-left: 0.5rem;
  line-height: 0.61rem;
  color: #737373;
  overflow: hidden;
  clear: both;
  cursor: pointer;
}
.catalogs .radia {
  width: 0.1rem;
  height: 0.1rem;
  margin-right: 0.2rem;
  border-radius: 0.06rem;
  background: #aeaeae;
}
.catalogs:hover {
  color: #ffffff;
  background: #23cebc;
}

.actiivtyli {
  color: #fff;
  background: #23cebc;
}
.actiivtyli .radia {
  background: #ffffff;
}

.catalogs:hover .radia {
  background: #ffffff;
}
/* li {
  width: 100%;
  text-align: left;
  height: 0.61rem;
  padding-left: 0.5rem;
  line-height: 0.61rem;
  color: #737373;
  overflow: hidden;
  clear: both;
  cursor: pointer;
}
li::marker {
  color: #aeaeae;
}
.actiivtyli {
  background: #23cebc;
  color: #ffffff;
}

li:hover {
  background: #23cebc;
  color: #ffffff;
} */
/* <li @click="onitemCheckEr(itemer.Id)"
                  class="font-size-22"
                  :class="itemer.Id == erindexId ? 'actiivtyli' : ''"
                  v-for="(itemer, erindex) in erCatalogs"
                  :key="erindex">
                {{ itemer.CatalogName }}
              </li> */
.firstdiv {
  background: url("../../../assets/icon-bg.jpg");
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  /* background-size: 100% auto; */
  position: fixed;
  /* height: 5.05rem; */
  top: 0;
  left: 0;
  z-index: -1;
  background-color: #cbfeee;
}

.content {
  padding-bottom: 0.56rem;
}

@keyframes slide-down {
  0% {
    transform: scale(1, 0);
  }
  100% {
    transform: scale(1, 1);
  }
}

@-webkit-keyframes slide-down {
  0% {
    -webkit-transform: scale(1, 0);
  }
  100% {
    -webkit-transform: scale(1, 1);
  }
}
.show {
  height: auto;
  transition: max-height 0.3s ease-in;
  transform-origin: 50% 0;
  animation: slide-down 0.3s ease-in;
  -webkit-animation: slide-down 0.3s ease-in;
}

.hidden {
  max-height: 0px;
  overflow: auto;
  transition: max-height 0.3s ease-out;
}
</style>



// WEBPACK FOOTER //
// src/view/tab/navigation/good_course.vue